(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._separatorLine_nzfcz_1{display:flex;border:0;margin:0;flex:none}._visuallyHidden_1gevf_1{border:0;clip:rect(0 0 0 0);height:1px;overflow:hidden;padding:0;position:absolute;white-space:nowrap;width:1px}._text_1iisw_1{--swui-text-color: var(--swui-text-primary-color);--swui-text-color-caption: var(--lhds-color-ui-600);--swui-text-color-overline: var(--lhds-color-ui-600);--swui-text-font-family: var(--swui-font-primary);--swui-text-font-weight: var(--swui-font-weight-text);--current-color: var(--swui-text-color);--current-font-size: var(--swui-font-size-medium);--current-line-height: var(--swui-line-height-medium);--current-font-weight: var(--swui-text-font-weight);--current-letter-spacing: var(--swui-text-letter-spacing);font-size:var(--current-font-size);line-height:var(--current-line-height);color:var(--current-color);letter-spacing:var(--current-letter-spacing);font-family:var(--swui-text-font-family);font-weight:var(--current-font-weight)}._text_1iisw_1._bold_1iisw_27{--current-font-weight: var(--swui-font-weight-text-bold)}._text_1iisw_1._caption_1iisw_31{--current-font-size: var(--swui-font-size-small);--current-line-height: var(--swui-line-height-small);--current-color: var(--swui-text-color-caption);--current-letter-spacing: 0;font-style:italic}._text_1iisw_1._overline_1iisw_39{--current-font-size: var(--swui-font-size-smaller);--current-line-height: var(--swui-line-height-smaller);--current-color: var(--swui-text-color-overline);--current-font-weight: var(--swui-font-weight-text-bold);--current-letter-spacing: .1rem;text-transform:uppercase}._text_1iisw_1._large_1iisw_48{--current-font-size: var(--swui-font-size-large);--current-line-height: var(--swui-line-height-large)}._text_1iisw_1._medium_1iisw_53{--current-font-size: var(--swui-font-size-medium);--current-line-height: var(--swui-line-height-medium)}._text_1iisw_1._small_1iisw_58{--current-font-size: var(--swui-font-size-small);--current-line-height: var(--swui-line-height-small)}._text_1iisw_1._smaller_1iisw_63{--current-font-size: var(--swui-font-size-smaller);--current-line-height: var(--swui-line-height-smaller)}._heading_1cnsg_1{font-size:2rem;color:var(--swui-text-primary-color);letter-spacing:0;margin:0;line-height:var(--swui-line-height);font-family:var(--swui-font-primary);font-weight:var(--swui-font-weight-text-bold)}._heading_1cnsg_1._h1_1cnsg_10{font-size:2.8rem}._heading_1cnsg_1._h2_1cnsg_14{font-size:2.4rem}._heading_1cnsg_1._h3_1cnsg_18{font-size:2rem}._heading_1cnsg_1._h4_1cnsg_22{font-size:1.8rem}._heading_1cnsg_1._h5_1cnsg_26{font-size:1.6rem}._heading_1cnsg_1._h6_1cnsg_30{font-size:1.4rem}")),document.head.appendChild(e)}}catch(i){console.error("vite-plugin-css-injected-by-js",i)}})();
import { cssColor as R } from "@stenajs-webui/theme";
import { jsx as i, Fragment as I } from "react/jsx-runtime";
import { forwardRef as h, useState as g, useCallback as p, useLayoutEffect as H, useRef as v, useEffect as l, useMemo as z } from "react";
import y from "@emotion/styled";
import F from "@emotion/is-prop-valid";
import { system as N, background as P, border as V, borderRight as A, borderLeft as G, borderTop as j, borderBottom as U, borderColor as q, borderRadius as W, borderStyle as B, borderWidth as K, boxShadow as J, flexbox as Q, overflow as X, position as Y, layout as Z, zIndex as ee, left as te, right as ne, top as re, bottom as se } from "styled-system";
import { pickBy as oe, debounce as ce } from "lodash";
import O from "classnames";
import * as ue from "react-dom";
const ie = "_separatorLine_nzfcz_1", ae = {
  separatorLine: ie
}, Ze = h(
  ({
    color: e = R("--lhds-color-ui-300"),
    size: t = "100%",
    width: n = "1px",
    vertical: r = !1
  }, s) => /* @__PURE__ */ i(
    "hr",
    {
      className: ae.separatorLine,
      "aria-hidden": !0,
      color: e,
      style: {
        backgroundColor: e,
        height: r ? t || "100%" : n || "1px",
        width: r ? n || "1px" : t || "100%"
      },
      ref: s
    }
  )
), de = y.button`
  display: inline-block;
  user-select: none;
  border: 0;
  padding: 0;
  background: ${({ background: e }) => e};
  ${({ pointer: e }) => e ? "cursor: pointer;" : ""}

  :hover {
    ${(e) => e.opacityOnHover ? "opacity: 0.7;" : ""};
    ${({ hoverBackground: e }) => `background: ${e};`}
  }
  :active {
    ${({ disableOpacityOnClick: e }) => e ? "" : "opacity: 0.5;"}
  }
  :focus {
    outline: 0;
    ${({ disableFocusHighlight: e }) => e ? "" : "box-shadow: 0 0 3pt 2pt rgba(0, 0, 100, 0.3);"}
    ${({ focusBackground: e }) => `background: ${e};`}
  }
  ${({ width: e }) => e ? `width: ${e};` : ""}
  ${({ height: e }) => e ? `height: ${e};` : ""}
  ${({ borderRadius: e }) => e ? `border-radius: ${e};` : ""}
`, et = h(
  ({
    disableFocusHighlight: e,
    onClick: t,
    onDblClick: n,
    tooltip: r,
    disableOpacityOnClick: s,
    disablePointer: o,
    opacityOnHover: c,
    disabled: a,
    children: u,
    background: d = "transparent",
    hoverBackground: m,
    focusBackground: f,
    type: D = "button",
    ...L
  }, k) => /* @__PURE__ */ i(
    de,
    {
      opacityOnHover: c,
      title: r,
      disabled: a,
      disableOpacityOnClick: s,
      onClick: t,
      onDoubleClick: n,
      disableFocusHighlight: e,
      pointer: !!(t || n) && !o,
      ref: k,
      background: d,
      hoverBackground: m,
      focusBackground: f,
      type: D,
      ...L,
      children: u
    }
  )
), $ = (e) => e == null ? 0 : typeof e == "boolean" ? e ? 1 : 0 : e, le = (e) => {
  if (e !== 0)
    return `calc(${e} * var(--swui-metrics-space))`;
}, S = (e) => le($(e)), me = {
  box: "var(--swui-shadow-box)",
  popover: "var(--swui-shadow-popover)",
  modal: "var(--swui-shadow-modal)",
  bottom: "var(--swui-shadow-bottom)"
}, pe = [
  "spacing",
  "indent",
  "gap",
  "width",
  "height",
  "overflow",
  "display"
], he = (e) => pe.includes(e), fe = N({
  row: {
    property: "flexDirection",
    transform: (e) => e ? "row" : "column"
  },
  indent: {
    // @ts-ignore
    property: "--current-indent",
    transform: $
  },
  spacing: {
    // @ts-ignore
    property: "--current-spacing",
    transform: $
  },
  gap: {
    // @ts-ignore
    property: "--current-gap",
    transform: $
  },
  columnGap: {
    property: "columnGap",
    transform: S
  },
  rowGap: {
    property: "rowGap",
    transform: S
  },
  shadow: {
    property: "boxShadow",
    transform: (e) => me[e] ?? e
  }
}), b = y("div", {
  shouldForwardProp: (e) => typeof e == "string" ? he(e) ? !1 : F(e) : !1
})`
  --current-spacing: 0;
  --current-indent: 0;
  --current-gap: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  ${fe};
  ${P};
  ${V};
  ${A};
  ${G};
  ${j};
  ${U};
  ${q};
  ${W};
  ${B};
  ${K};
  ${J};
  ${Q};
  ${X};
  ${Y};
  ${Z};
  ${ee};
  ${te};
  ${ne};
  ${re};
  ${se};

  gap: calc(var(--current-gap) * var(--swui-metrics-space));

  padding: calc(var(--current-spacing) * var(--swui-metrics-spacing))
    calc(var(--current-indent) * var(--swui-metrics-indent));

  :hover {
    ${({ hoverBackground: e }) => e ? `background: ${e};` : ""}
    ${({ hoverBorder: e }) => e ? `border: ${e};` : ""}
  }

  :focus {
    ${({ focusBackground: e }) => e ? `background: ${e};` : ""}
    ${({ focusBorder: e }) => e ? `border: ${e};` : ""}
  }

  :focus-within {
    ${({ focusWithinBackground: e }) => e ? `background: ${e};` : ""}
    ${({ focusWithinBorder: e }) => e ? `border: ${e};` : ""}
  }
`, tt = h(function(t, n) {
  return /* @__PURE__ */ i(b, { ref: n, ...t });
}), ge = (e) => {
  const { x: t, y: n, width: r, height: s, bottom: o, top: c, left: a, right: u } = e.getBoundingClientRect();
  return {
    width: r,
    height: s,
    top: c,
    left: a,
    x: t,
    y: n,
    right: u,
    bottom: o
  };
}, ve = (e, t) => e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height && e.bottom === t.bottom && e.top === t.top && e.left === t.left && e.right === t.right, we = (e, t) => {
  const [n, r] = g(), s = p(() => {
    window.requestAnimationFrame(() => {
      if (e.current) {
        const o = ge(e.current);
        (!n || !ve(n, o)) && t && t(o), r(o);
      }
    });
  }, [e, n, r, t]);
  return H(() => {
    s();
  }, [s]), {
    dimensions: n
  };
}, nt = h(
  function({ onResize: t, ...n }, r) {
    const s = v(null);
    return we(r ?? s, t), /* @__PURE__ */ i(b, { ...n, ref: r });
  }
), rt = h(function(t, n) {
  return /* @__PURE__ */ i(b, { row: !0, ref: n, ...t });
}), st = h(function({ num: t = 1, ...n }, r) {
  return /* @__PURE__ */ i(b, { indent: t, ref: r, ...n });
}), ot = h(
  function({ num: t = 1, ...n }, r) {
    return /* @__PURE__ */ i(b, { spacing: t, ref: r, ...n });
  }
), be = y.div`
  --current-size: 1;
  flex: none;
  width: calc(var(--current-size) * var(--swui-metrics-space));
  height: calc(var(--current-size) * var(--swui-metrics-space));
`, ct = ({
  half: e = !1,
  horizontal: t = !1,
  num: n = 1,
  vertical: r = !1
}) => {
  const s = n * (e ? 0.5 : 1);
  return /* @__PURE__ */ i(
    be,
    {
      style: {
        "--current-size": s,
        height: t ? 1 : void 0,
        width: r ? 1 : void 0
      }
    }
  );
}, ut = ({ children: e, nest: t, render: n }) => t ? /* @__PURE__ */ i(I, { children: n(e) }) : /* @__PURE__ */ i(I, { children: e }), _e = "_visuallyHidden_1gevf_1", $e = {
  visuallyHidden: _e
}, xe = (e) => oe(e, ye), ye = (e, t) => Ee(t), Ee = (e) => e.startsWith("data-") || e.startsWith("aria-"), it = ({
  children: e,
  ...t
}) => /* @__PURE__ */ i("span", { className: $e.visuallyHidden, ...xe(t), children: e }), Ie = "_text_1iisw_1", Se = "_standard_1iisw_24", Ce = "_bold_1iisw_27", Te = "_caption_1iisw_31", Me = "_overline_1iisw_39", Oe = "_large_1iisw_48", De = "_medium_1iisw_53", Le = "_small_1iisw_58", ke = "_smaller_1iisw_63", x = {
  text: Ie,
  standard: Se,
  bold: Ce,
  caption: Te,
  overline: Me,
  large: Oe,
  medium: De,
  small: Le,
  smaller: ke
}, _ = h(
  ({
    children: e,
    variant: t = "standard",
    size: n = "medium",
    className: r,
    color: s,
    userSelect: o,
    whiteSpace: c,
    wordBreak: a,
    textAlign: u,
    style: d,
    ...m
  }, f) => /* @__PURE__ */ i(
    "span",
    {
      className: O(x.text, x[t], x[n], r),
      ref: f,
      style: {
        color: s,
        userSelect: o,
        whiteSpace: c,
        wordBreak: a,
        textAlign: u,
        ...d
      },
      ...m,
      children: e
    }
  )
), at = _, dt = (e) => /* @__PURE__ */ i(_, { size: "small", ...e }), lt = (e) => /* @__PURE__ */ i(_, { size: "smaller", ...e }), mt = (e) => /* @__PURE__ */ i(_, { size: "medium", ...e }), pt = (e) => /* @__PURE__ */ i(_, { size: "large", ...e }), Re = "_heading_1cnsg_1", He = "_h1_1cnsg_10", ze = "_h2_1cnsg_14", Fe = "_h3_1cnsg_18", Ne = "_h4_1cnsg_22", Pe = "_h5_1cnsg_26", Ve = "_h6_1cnsg_30", C = {
  heading: Re,
  h1: He,
  h2: ze,
  h3: Fe,
  h4: Ne,
  h5: Pe,
  h6: Ve
}, Ae = h(
  ({
    variant: e = "h3",
    className: t,
    color: n,
    whiteSpace: r,
    wordBreak: s,
    style: o,
    children: c,
    as: a,
    ...u
  }, d) => /* @__PURE__ */ i(
    a ?? e,
    {
      className: O(C.heading, C[e], t),
      style: { color: n, whiteSpace: r, wordBreak: s, ...o },
      ref: d,
      ...u,
      children: c
    }
  )
), ht = (e) => /* @__PURE__ */ i(Ae, { variant: "h2", ...e }), Ge = (e, t) => e === t, ft = (e, t, n = Ge) => {
  const r = p(
    (u) => {
      e.some((d) => n(d, u)) || t([...e, u]);
    },
    [e, t, n]
  ), s = p(
    (u) => {
      t(
        u.reduce((d, m) => d.some((f) => n(f, m)) ? d : [...d, m], e)
      );
    },
    [e, t, n]
  ), o = p(
    (u) => {
      const d = e.findIndex((m) => n(m, u));
      d >= 0 && t(e.filter((m, f) => f !== d));
    },
    [e, t, n]
  ), c = p(
    (u) => {
      t(e.filter((d) => !u.some((m) => n(m, d))));
    },
    [e, t, n]
  ), a = p(
    (u) => {
      e.some((m) => n(m, u)) ? o(u) : r(u);
    },
    [e, r, o, n]
  );
  return {
    add: r,
    addMultiple: s,
    remove: o,
    removeMultiple: c,
    toggle: a
  };
}, E = (e) => {
  const [t, n] = g(e), r = p(() => {
    n(!0);
  }, [n]), s = p(() => {
    n(!1);
  }, [n]), o = p(() => {
    n((c) => !c);
  }, [n]);
  return [t, r, s, o];
}, gt = (e, t) => {
  const [n, r] = g(e);
  return l(() => {
    const s = setTimeout(() => {
      r(e);
    }, t);
    return () => {
      clearTimeout(s);
    };
  }, [e, t]), n;
}, vt = (e, t) => {
  const [n, r] = g(e);
  return l(() => {
    e && r(!0);
    const s = setTimeout(() => {
      e || r(e);
    }, t);
    return () => {
      clearTimeout(s);
    };
  }, [e, t]), n;
};
let je = 0;
const T = (e) => `webui-${e ? e + "-" : ""}${++je}`, wt = (e) => {
  const [t, n] = g(() => T(e));
  return l(() => n(T(e)), [e]), t;
}, w = (e, t, n) => {
  const r = v();
  l(() => {
    r.current = n;
  }, [n]), l(() => {
    if (!(e.current && e.current.addEventListener))
      return;
    const o = (a) => {
      if (r.current)
        return r.current(a);
    };
    if (!e.current)
      return;
    const c = e.current;
    return c.addEventListener(t, o), () => {
      c && c.removeEventListener(t, o);
    };
  }, [t, e]);
}, bt = (e) => {
  const [t, n, r] = E(!1);
  l(() => {
    document.activeElement === ue.findDOMNode(e.current) ? n() : r();
  }, [e, r, n]), w(e, "focus", n), w(e, "blur", r);
  const s = p(() => {
    e.current && e.current.focus();
  }, [e]), o = p(() => {
    e.current && e.current.blur();
  }, [e]);
  return { isInFocus: t, focus: s, blur: o };
}, _t = (e) => {
  const [t, n, r] = E(!1);
  return w(e, "mouseover", n), w(e, "mouseout", r), t;
}, $t = (e) => {
  const [t, n, r] = E(!1);
  return w(e, "mouseenter", n), w(e, "mouseleave", r), t;
}, xt = (e, t) => {
  const n = v(() => {
  });
  l(() => {
    n.current = t;
  }, [t]), l(() => {
    const r = (s) => {
      e.filter((c) => c.current).every((c) => c.current && !c.current.contains(s.target)) && n.current(s);
    };
    return document.addEventListener("mousedown", r), document.addEventListener("touchstart", r), () => {
      document.removeEventListener("mousedown", r), document.removeEventListener("touchstart", r);
    };
  }, [...e]);
}, yt = (e, t, n) => {
  const r = v(() => {
  });
  l(() => {
    r.current = t;
  }, [t]), l(() => {
    const s = (o) => {
      !e.current || e.current.contains(o.target) || r.current(o);
    };
    return document.addEventListener("mousedown", s, n), document.addEventListener("touchstart", s, n), () => {
      document.removeEventListener("mousedown", s, n), document.removeEventListener("touchstart", s, n);
    };
  }, [e, n]);
}, M = ["mousemove", "mousedown", "keydown", "touchstart", "scroll"], Et = (e, t) => {
  const n = v(() => {
  });
  l(() => {
    n.current = e;
  }, [e]), l(() => {
    const r = ce(n.current, t);
    return M.forEach((s) => window.addEventListener(s, r)), () => {
      M.forEach(
        (s) => window.removeEventListener(s, r)
      );
    };
  }, [t]);
}, It = (e, t) => {
  const [n, r] = g(!1), { rootMargin: s, root: o, threshold: c } = t || {}, a = z(() => new IntersectionObserver(
    ([u]) => r(u.isIntersecting),
    {
      rootMargin: s,
      root: o,
      threshold: c
    }
  ), [r, s, o, c]);
  return l(() => (e.current && a.observe(e.current), () => {
    a.disconnect();
  }), [a, e]), n;
}, St = (e) => {
  const t = v(null);
  return l(() => {
    e && (typeof e == "function" ? e(t.current) : e.current = t.current);
  }), t;
}, Ct = (e, t, n = !0) => {
  const [r, s] = g(e), o = v(), c = p(
    (a, u = t) => {
      s(a), n && clearTimeout(o.current), o.current = setTimeout(() => s(e), u);
    },
    [t, n, e]
  );
  return l(() => () => {
    clearTimeout(o.current);
  }, []), [r, c];
}, Tt = (e) => {
  throw new Error(`Switch unhandled case: ${e}`);
}, Mt = (e, t) => t, Ot = (e) => Object.keys(e).filter((t) => e[t]), Dt = (e) => {
  try {
    const t = parseFloat(e);
    return isNaN(t) || t == null ? void 0 : t;
  } catch {
  }
}, Lt = (e) => {
  try {
    const t = parseInt(e, 10);
    return isNaN(t) || t == null ? void 0 : t;
  } catch {
  }
};
export {
  b as Box,
  et as Clickable,
  tt as Column,
  ht as HeaderText,
  Ae as Heading,
  st as Indent,
  pt as LargeText,
  ut as Nest,
  nt as ResizeAwareBox,
  rt as Row,
  it as ScreenReaderOnlyText,
  Ze as SeparatorLine,
  dt as SmallText,
  lt as SmallerText,
  ct as Space,
  ot as Spacing,
  mt as StandardText,
  _ as Text,
  at as Txt,
  $ as booleanOrNumberToNumber,
  Mt as exhaustSwitchCase,
  Tt as exhaustSwitchCaseElseThrow,
  xe as getDataProps,
  ge as getDimensionObject,
  Dt as parseFloatElseUndefined,
  Lt as parseIntElseUndefined,
  Ot as truthyKeysAsList,
  ft as useArraySet,
  E as useBoolean,
  gt as useDebounce,
  vt as useDelayedFalse,
  wt as useDomId,
  we as useElementDimensions,
  bt as useElementFocus,
  w as useEventListener,
  St as useForwardedRef,
  $t as useMouseIsEntered,
  _t as useMouseIsOver,
  xt as useMultiOnClickOutside,
  yt as useOnClickOutside,
  Et as useOnNoMouseMovement,
  It as useOnScreen,
  Ct as useTimeoutState
};
//# sourceMappingURL=index.es.js.map
